// Ensure this import path is correct based on your folder structure
import { generatePreDisasterAlertExcel } from '../excelUtilsPreDisasterAlert';

export const isPreDisasterAlertReport = (toolName) => {
  if (!toolName) return false;
  const name = toolName.toLowerCase();
  return name === 'pre_disaster_alert_report' || name === 'predisasteralertreport';
};

export const handlePreDisasterAlertDownload = async (message, format) => {
  try {
    // Target 'notifications' based on your console log: {notifications: [...]}
    const rawData = message.debug?.tool_result?.result?.data?.notifications || 
                    message.debug?.tool_result?.result?.data;

    if (!rawData || (Array.isArray(rawData) && rawData.length === 0)) {
      alert("No alert data available to download.");
      return;
    }

    if (format === 'excel') {
      await generatePreDisasterAlertExcel({
        data: rawData,
        filename: 'Pre_Disaster_Alert_Report'
      });
    }
  } catch (error) {
    console.error("❌ Pre-Disaster Alert Download Error:", error);
  }
};